import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(AnalyticsRoutes);

    /** @ngInject */
    function AnalyticsRoutes($stateProvider) {
        $stateProvider
            .state('company_employee.analytics', {
                url: '/analityka',
                template: '<div class="container-fluid" ui-view></div>',
            })
            .state('company_employee.analytics.issues', {
                url: '/analityka-zgloszen',
                template:
                    require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/analytics/issues-analytics/issues-analytics-container.html'),
                controller: 'IssueAnalyticsWrapperController',
                controllerAs: 'IssueAnalyticsWrapperCtrl',
            })
            .state('company_employee.analytics.groups', {
                url: '/analityka-grupowa',
                template:
                    require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/analytics/group-analytics/group-analytics-container.html'),
                controller: 'GroupAnalyticsWrapperController',
                controllerAs: 'GroupAnalyticsWrapperCtrl',
            })
            .state('company_employee.analytics.clients_report', {
                url: '/raport-klienci',
                template:
                    require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/analytics/clients-report/clients-report.html'),
                controller: 'ClientsReportController',
                controllerAs: 'ClientsReportCtrl',
            })
            .state('company_employee.analytics.employees_report', {
                url: '/raport-pracownicy',
                template:
                    require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/analytics/employees-report/employees-report.html'),
                controller: 'EmployeesReportController',
                controllerAs: 'EmployeesReportCtrl',
            });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/analytics/analytics.route.ts